import { getFieldCapacityByDayFeature } from '@dispatch/shared/services';
import { isEmpty } from 'lodash';
import { useQuery } from '../useQuery';

/**
 * Per-tenant kill-switch for the per-day field capacity model (ADO #94651).
 *
 * Defaults to `false` while the query is disabled, in flight, or errored so an
 * unresolved flag renders the legacy single Field Capacity input rather than
 * optimistically exposing the per-day grid.
 */
export const useGetFieldCapacityByDayFeature = (
  tenantId: string,
  enabled = true
) => {
  const { data, status, refetch } = useQuery(
    ['field-capacity-by-day-feature', tenantId],
    () => getFieldCapacityByDayFeature(tenantId),
    {
      enabled: enabled && !isEmpty(tenantId),
    }
  );

  return {
    feature: data || false,
    featureStatus: status,
    fetchFeature: refetch,
  };
};
